module.exports = __webpack_public_path__ + "img/paragraph.6f8a8769.svg";